import type { TemperaLayerImage } from '../types';

// packages/lyric-stage/src/services/temperaImageArchive.ts
// Stub archive import/export for standalone package.

export class TemperaArchiveTooLargeError extends Error {
  constructor(message = 'Tempera archive too large') {
    super(message);
    this.name = 'TemperaArchiveTooLargeError';
  }
}

export interface TemperaImagePoolSnapshot {
  layerImages: TemperaLayerImage[];
}

export interface TemperaImageArchiveExportResult {
  blob: Blob;
  exported: number;
  skipped: number;
}

export interface TemperaImageArchiveImportResult {
  layerImages: TemperaLayerImage[];
  skipped: number;
  truncated: number;
}

export const createTemperaImageArchive = async (
  snapshot: TemperaImagePoolSnapshot,
): Promise<TemperaImageArchiveExportResult> => ({
  blob: new Blob([], { type: 'application/zip' }),
  exported: 0,
  skipped: snapshot.layerImages.length,
});

export const readTemperaImageArchiveFile = async (
  _file: File,
  options: { existing: TemperaLayerImage[]; maxImages?: number; signal?: AbortSignal },
): Promise<TemperaImageArchiveImportResult> => ({
  layerImages: options.existing,
  skipped: 0,
  truncated: 0,
});
